/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Text, Theme, useTheme, VFlow } from 'bold-ui'
import { Fragment } from 'react'
import { dateAsDdMmYyyy } from 'util/date/formatDate'

import { ReactComponent as SdcIcon } from '../../../../../../images/suporte-decisao-clinica/health-system-outline.svg'
import { RiscoPreEclampsiaTag } from './RiscoPreEclampsiaTag'

export function SdcRiscoPreEclampsiaSection() {
  //TODO@Codebenders: usar valor retornado pelo DB após conclusão da issue #26441
  const ultimaAtualizacao = dateAsDdMmYyyy(new Date())
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Fragment>
      <hr css={styles.topLine} />
      <VFlow vSpacing={0.75}>
        <VFlow vSpacing={0.5}>
          <HFlow alignItems='center' justifyContent='space-between'>
            <HFlow hSpacing={0.5} alignItems='center' justifyContent='flex-start'>
              <SdcIcon />
              <Text component='h4' variant='h4' fontWeight='bold'>
                Suporte à Decisão Clínica
              </Text>
            </HFlow>
            <Text component='h5' variant='h5' fontWeight='normal' fontStyle='italic' style={styles.lastUpdate}>
              Risco atualizado pelo SDC em {ultimaAtualizacao}
            </Text>
          </HFlow>
          <Text component='h5' variant='h5' fontWeight='normal'>
            O SDC identifica riscos com base nos dados do prontuário. Para uma avaliação precisa, verifique se os
            fatores de risco estão registrados.
          </Text>
        </VFlow>
        <VFlow vSpacing={0.5}>
          <Text component='h5' variant='h5' fontWeight='bold'>
            Risco de pré-eclâmpsia:
          </Text>
          <RiscoPreEclampsiaTag dataTestId='SdcRiscoPreEclampsiaSection.riscoPreEclampsiaTag' />
        </VFlow>
      </VFlow>
    </Fragment>
  )
}

const createStyles = (theme: Theme) => ({
  topLine: css`
    margin: 0.75rem 0 1.25rem 0;
  `,
  lastUpdate: css`
    color: ${theme.pallete.gray.c40};
  `,
})
